import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_CASE_PROVIDERS = "GET_CASE_PROVIDERS";

export const service = async () => {
  const options: object = {
    url: "/api/lookup/GetCaseProviders/",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_PROVIDERS, service, mock);
